export const EcoCssInJsBezierEaseOutBack = "cubic-bezier(0.34, 1.56, 0.64, 1)";
export const EcoCssInJsBezierEaseInOutSine = "cubic-bezier(0.37, 0, 0.63, 1)";
export const EcoCssInJsSpeedSuperFast = 50;
export const EcoCssInJsSpeedFast = 100;
export const EcoCssInJsSpeedNormal = 150;
export const EcoCssInJsSpeedSlow = 250;
export const EcoCssInJsSpeedSuperSlow = 450;
export const EcoCssInJsBaseSize = "clamp(1rem, 0.875vw, 1.375rem)";
export const EcoCssInJsCAgnosticAmberHsl = "35, 100%, 55.5%";
export const EcoCssInJsCAgnosticAmber = "hsl(35, 100%, 55.5%)";
export const EcoCssInJsCAgnosticAmberTransparent = "hsla(35, 100%, 55.5%, 0)";
export const EcoCssInJsCAgnosticAmberMinor = "hsla(35, 100%, 55.5%, 0.15)";
export const EcoCssInJsCAgnosticAmberWeak = "hsla(35, 100%, 55.5%, 0.3)";
export const EcoCssInJsCAgnosticAmberMedium = "hsla(35, 100%, 55.5%, 0.5)";
export const EcoCssInJsCAgnosticAmberHeavy = "hsla(35, 100%, 55.5%, 0.7)";
export const EcoCssInJsCAgnosticAmberMajor = "hsla(35, 100%, 55.5%, 0.85)";
export const EcoCssInJsCAgnosticAmberOpaque = "hsla(35, 100%, 55.5%, 1)";
export const EcoCssInJsCAgnosticBlackHsl = "0, 0%, 0%";
export const EcoCssInJsCAgnosticBlack = "hsl(0, 0%, 0%)";
export const EcoCssInJsCAgnosticBlackTransparent = "hsla(0, 0%, 0%, 0)";
export const EcoCssInJsCAgnosticBlackMinor = "hsla(0, 0%, 0%, 0.15)";
export const EcoCssInJsCAgnosticBlackWeak = "hsla(0, 0%, 0%, 0.3)";
export const EcoCssInJsCAgnosticBlackMedium = "hsla(0, 0%, 0%, 0.5)";
export const EcoCssInJsCAgnosticBlackHeavy = "hsla(0, 0%, 0%, 0.7)";
export const EcoCssInJsCAgnosticBlackMajor = "hsla(0, 0%, 0%, 0.85)";
export const EcoCssInJsCAgnosticBlackOpaque = "hsla(0, 0%, 0%, 1)";
export const EcoCssInJsCAgnosticBlueHsl = "208, 100%, 47.3%";
export const EcoCssInJsCAgnosticBlue = "hsl(208, 100%, 47.3%)";
export const EcoCssInJsCAgnosticBlueTransparent = "hsla(208, 100%, 47.3%, 0)";
export const EcoCssInJsCAgnosticBlueMinor = "hsla(208, 100%, 47.3%, 0.15)";
export const EcoCssInJsCAgnosticBlueWeak = "hsla(208, 100%, 47.3%, 0.3)";
export const EcoCssInJsCAgnosticBlueMedium = "hsla(208, 100%, 47.3%, 0.5)";
export const EcoCssInJsCAgnosticBlueHeavy = "hsla(208, 100%, 47.3%, 0.7)";
export const EcoCssInJsCAgnosticBlueMajor = "hsla(208, 100%, 47.3%, 0.85)";
export const EcoCssInJsCAgnosticBlueOpaque = "hsla(208, 100%, 47.3%, 1)";
export const EcoCssInJsCAgnosticBronzeHsl = "17.9, 20%, 53.9%";
export const EcoCssInJsCAgnosticBronze = "hsl(17.9, 20%, 53.9%)";
export const EcoCssInJsCAgnosticBronzeTransparent = "hsla(17.9, 20%, 53.9%, 0)";
export const EcoCssInJsCAgnosticBronzeMinor = "hsla(17.9, 20%, 53.9%, 0.15)";
export const EcoCssInJsCAgnosticBronzeWeak = "hsla(17.9, 20%, 53.9%, 0.3)";
export const EcoCssInJsCAgnosticBronzeMedium = "hsla(17.9, 20%, 53.9%, 0.5)";
export const EcoCssInJsCAgnosticBronzeHeavy = "hsla(17.9, 20%, 53.9%, 0.7)";
export const EcoCssInJsCAgnosticBronzeMajor = "hsla(17.9, 20%, 53.9%, 0.85)";
export const EcoCssInJsCAgnosticBronzeOpaque = "hsla(17.9, 20%, 53.9%, 1)";
export const EcoCssInJsCAgnosticBrownHsl = "27, 31.8%, 47.6%";
export const EcoCssInJsCAgnosticBrown = "hsl(27, 31.8%, 47.6%)";
export const EcoCssInJsCAgnosticBrownTransparent = "hsla(27, 31.8%, 47.6%, 0)";
export const EcoCssInJsCAgnosticBrownMinor = "hsla(27, 31.8%, 47.6%, 0.15)";
export const EcoCssInJsCAgnosticBrownWeak = "hsla(27, 31.8%, 47.6%, 0.3)";
export const EcoCssInJsCAgnosticBrownMedium = "hsla(27, 31.8%, 47.6%, 0.5)";
export const EcoCssInJsCAgnosticBrownHeavy = "hsla(27, 31.8%, 47.6%, 0.7)";
export const EcoCssInJsCAgnosticBrownMajor = "hsla(27, 31.8%, 47.6%, 0.85)";
export const EcoCssInJsCAgnosticBrownOpaque = "hsla(27, 31.8%, 47.6%, 1)";
export const EcoCssInJsCAgnosticCrimsonHsl = "336, 73.7%, 53.5%";
export const EcoCssInJsCAgnosticCrimson = "hsl(336, 73.7%, 53.5%)";
export const EcoCssInJsCAgnosticCrimsonTransparent = "hsla(336, 73.7%, 53.5%, 0)";
export const EcoCssInJsCAgnosticCrimsonMinor = "hsla(336, 73.7%, 53.5%, 0.15)";
export const EcoCssInJsCAgnosticCrimsonWeak = "hsla(336, 73.7%, 53.5%, 0.3)";
export const EcoCssInJsCAgnosticCrimsonMedium = "hsla(336, 73.7%, 53.5%, 0.5)";
export const EcoCssInJsCAgnosticCrimsonHeavy = "hsla(336, 73.7%, 53.5%, 0.7)";
export const EcoCssInJsCAgnosticCrimsonMajor = "hsla(336, 73.7%, 53.5%, 0.85)";
export const EcoCssInJsCAgnosticCrimsonOpaque = "hsla(336, 73.7%, 53.5%, 1)";
export const EcoCssInJsCAgnosticCyanHsl = "191, 91.2%, 36.8%";
export const EcoCssInJsCAgnosticCyan = "hsl(191, 91.2%, 36.8%)";
export const EcoCssInJsCAgnosticCyanTransparent = "hsla(191, 91.2%, 36.8%, 0)";
export const EcoCssInJsCAgnosticCyanMinor = "hsla(191, 91.2%, 36.8%, 0.15)";
export const EcoCssInJsCAgnosticCyanWeak = "hsla(191, 91.2%, 36.8%, 0.3)";
export const EcoCssInJsCAgnosticCyanMedium = "hsla(191, 91.2%, 36.8%, 0.5)";
export const EcoCssInJsCAgnosticCyanHeavy = "hsla(191, 91.2%, 36.8%, 0.7)";
export const EcoCssInJsCAgnosticCyanMajor = "hsla(191, 91.2%, 36.8%, 0.85)";
export const EcoCssInJsCAgnosticCyanOpaque = "hsla(191, 91.2%, 36.8%, 1)";
export const EcoCssInJsCAgnosticGoldHsl = "36, 19.8%, 49.4%";
export const EcoCssInJsCAgnosticGold = "hsl(36, 19.8%, 49.4%)";
export const EcoCssInJsCAgnosticGoldTransparent = "hsla(36, 19.8%, 49.4%, 0)";
export const EcoCssInJsCAgnosticGoldMinor = "hsla(36, 19.8%, 49.4%, 0.15)";
export const EcoCssInJsCAgnosticGoldWeak = "hsla(36, 19.8%, 49.4%, 0.3)";
export const EcoCssInJsCAgnosticGoldMedium = "hsla(36, 19.8%, 49.4%, 0.5)";
export const EcoCssInJsCAgnosticGoldHeavy = "hsla(36, 19.8%, 49.4%, 0.7)";
export const EcoCssInJsCAgnosticGoldMajor = "hsla(36, 19.8%, 49.4%, 0.85)";
export const EcoCssInJsCAgnosticGoldOpaque = "hsla(36, 19.8%, 49.4%, 1)";
export const EcoCssInJsCAgnosticGrassHsl = "132, 43.1%, 42.2%";
export const EcoCssInJsCAgnosticGrass = "hsl(132, 43.1%, 42.2%)";
export const EcoCssInJsCAgnosticGrassTransparent = "hsla(132, 43.1%, 42.2%, 0)";
export const EcoCssInJsCAgnosticGrassMinor = "hsla(132, 43.1%, 42.2%, 0.15)";
export const EcoCssInJsCAgnosticGrassWeak = "hsla(132, 43.1%, 42.2%, 0.3)";
export const EcoCssInJsCAgnosticGrassMedium = "hsla(132, 43.1%, 42.2%, 0.5)";
export const EcoCssInJsCAgnosticGrassHeavy = "hsla(132, 43.1%, 42.2%, 0.7)";
export const EcoCssInJsCAgnosticGrassMajor = "hsla(132, 43.1%, 42.2%, 0.85)";
export const EcoCssInJsCAgnosticGrassOpaque = "hsla(132, 43.1%, 42.2%, 1)";
export const EcoCssInJsCAgnosticGrayHsl = "0, 0%, 56.1%";
export const EcoCssInJsCAgnosticGray = "hsl(0, 0%, 56.1%)";
export const EcoCssInJsCAgnosticGrayTransparent = "hsla(0, 0%, 56.1%, 0)";
export const EcoCssInJsCAgnosticGrayMinor = "hsla(0, 0%, 56.1%, 0.15)";
export const EcoCssInJsCAgnosticGrayWeak = "hsla(0, 0%, 56.1%, 0.3)";
export const EcoCssInJsCAgnosticGrayMedium = "hsla(0, 0%, 56.1%, 0.5)";
export const EcoCssInJsCAgnosticGrayHeavy = "hsla(0, 0%, 56.1%, 0.7)";
export const EcoCssInJsCAgnosticGrayMajor = "hsla(0, 0%, 56.1%, 0.85)";
export const EcoCssInJsCAgnosticGrayOpaque = "hsla(0, 0%, 56.1%, 1)";
export const EcoCssInJsCAgnosticGreenHsl = "152, 57.5%, 37.6%";
export const EcoCssInJsCAgnosticGreen = "hsl(152, 57.5%, 37.6%)";
export const EcoCssInJsCAgnosticGreenTransparent = "hsla(152, 57.5%, 37.6%, 0)";
export const EcoCssInJsCAgnosticGreenMinor = "hsla(152, 57.5%, 37.6%, 0.15)";
export const EcoCssInJsCAgnosticGreenWeak = "hsla(152, 57.5%, 37.6%, 0.3)";
export const EcoCssInJsCAgnosticGreenMedium = "hsla(152, 57.5%, 37.6%, 0.5)";
export const EcoCssInJsCAgnosticGreenHeavy = "hsla(152, 57.5%, 37.6%, 0.7)";
export const EcoCssInJsCAgnosticGreenMajor = "hsla(152, 57.5%, 37.6%, 0.85)";
export const EcoCssInJsCAgnosticGreenOpaque = "hsla(152, 57.5%, 37.6%, 1)";
export const EcoCssInJsCAgnosticIndigoHsl = "226, 58.6%, 51.3%";
export const EcoCssInJsCAgnosticIndigo = "hsl(226, 58.6%, 51.3%)";
export const EcoCssInJsCAgnosticIndigoTransparent = "hsla(226, 58.6%, 51.3%, 0)";
export const EcoCssInJsCAgnosticIndigoMinor = "hsla(226, 58.6%, 51.3%, 0.15)";
export const EcoCssInJsCAgnosticIndigoWeak = "hsla(226, 58.6%, 51.3%, 0.3)";
export const EcoCssInJsCAgnosticIndigoMedium = "hsla(226, 58.6%, 51.3%, 0.5)";
export const EcoCssInJsCAgnosticIndigoHeavy = "hsla(226, 58.6%, 51.3%, 0.7)";
export const EcoCssInJsCAgnosticIndigoMajor = "hsla(226, 58.6%, 51.3%, 0.85)";
export const EcoCssInJsCAgnosticIndigoOpaque = "hsla(226, 58.6%, 51.3%, 1)";
export const EcoCssInJsCAgnosticLightBlueHsl = "228.5, 100%, 67.3%";
export const EcoCssInJsCAgnosticLightBlue = "hsl(228.5, 100%, 67.3%)";
export const EcoCssInJsCAgnosticLightBlueTransparent = "hsla(228.5, 100%, 67.3%, 0)";
export const EcoCssInJsCAgnosticLightBlueMinor = "hsla(228.5, 100%, 67.3%, 0.15)";
export const EcoCssInJsCAgnosticLightBlueWeak = "hsla(228.5, 100%, 67.3%, 0.3)";
export const EcoCssInJsCAgnosticLightBlueMedium = "hsla(228.5, 100%, 67.3%, 0.5)";
export const EcoCssInJsCAgnosticLightBlueHeavy = "hsla(228.5, 100%, 67.3%, 0.7)";
export const EcoCssInJsCAgnosticLightBlueMajor = "hsla(228.5, 100%, 67.3%, 0.85)";
export const EcoCssInJsCAgnosticLightBlueOpaque = "hsla(228.5, 100%, 67.3%, 1)";
export const EcoCssInJsCAgnosticLimeHsl = "80, 68.3%, 46.9%";
export const EcoCssInJsCAgnosticLime = "hsl(80, 68.3%, 46.9%)";
export const EcoCssInJsCAgnosticLimeTransparent = "hsla(80, 68.3%, 46.9%, 0)";
export const EcoCssInJsCAgnosticLimeMinor = "hsla(80, 68.3%, 46.9%, 0.15)";
export const EcoCssInJsCAgnosticLimeWeak = "hsla(80, 68.3%, 46.9%, 0.3)";
export const EcoCssInJsCAgnosticLimeMedium = "hsla(80, 68.3%, 46.9%, 0.5)";
export const EcoCssInJsCAgnosticLimeHeavy = "hsla(80, 68.3%, 46.9%, 0.7)";
export const EcoCssInJsCAgnosticLimeMajor = "hsla(80, 68.3%, 46.9%, 0.85)";
export const EcoCssInJsCAgnosticLimeOpaque = "hsla(80, 68.3%, 46.9%, 1)";
export const EcoCssInJsCAgnosticMauveHsl = "255, 3.7%, 57.3%";
export const EcoCssInJsCAgnosticMauve = "hsl(255, 3.7%, 57.3%)";
export const EcoCssInJsCAgnosticMauveTransparent = "hsla(255, 3.7%, 57.3%, 0)";
export const EcoCssInJsCAgnosticMauveMinor = "hsla(255, 3.7%, 57.3%, 0.15)";
export const EcoCssInJsCAgnosticMauveWeak = "hsla(255, 3.7%, 57.3%, 0.3)";
export const EcoCssInJsCAgnosticMauveMedium = "hsla(255, 3.7%, 57.3%, 0.5)";
export const EcoCssInJsCAgnosticMauveHeavy = "hsla(255, 3.7%, 57.3%, 0.7)";
export const EcoCssInJsCAgnosticMauveMajor = "hsla(255, 3.7%, 57.3%, 0.85)";
export const EcoCssInJsCAgnosticMauveOpaque = "hsla(255, 3.7%, 57.3%, 1)";
export const EcoCssInJsCAgnosticMintHsl = "167, 59.3%, 63.1%";
export const EcoCssInJsCAgnosticMint = "hsl(167, 59.3%, 63.1%)";
export const EcoCssInJsCAgnosticMintTransparent = "hsla(167, 59.3%, 63.1%, 0)";
export const EcoCssInJsCAgnosticMintMinor = "hsla(167, 59.3%, 63.1%, 0.15)";
export const EcoCssInJsCAgnosticMintWeak = "hsla(167, 59.3%, 63.1%, 0.3)";
export const EcoCssInJsCAgnosticMintMedium = "hsla(167, 59.3%, 63.1%, 0.5)";
export const EcoCssInJsCAgnosticMintHeavy = "hsla(167, 59.3%, 63.1%, 0.7)";
export const EcoCssInJsCAgnosticMintMajor = "hsla(167, 59.3%, 63.1%, 0.85)";
export const EcoCssInJsCAgnosticMintOpaque = "hsla(167, 59.3%, 63.1%, 1)";
export const EcoCssInJsCAgnosticOliveHsl = "111.4, 3.1%, 55.5%";
export const EcoCssInJsCAgnosticOlive = "hsl(111.4, 3.1%, 55.5%)";
export const EcoCssInJsCAgnosticOliveTransparent = "hsla(111.4, 3.1%, 55.5%, 0)";
export const EcoCssInJsCAgnosticOliveMinor = "hsla(111.4, 3.1%, 55.5%, 0.15)";
export const EcoCssInJsCAgnosticOliveWeak = "hsla(111.4, 3.1%, 55.5%, 0.3)";
export const EcoCssInJsCAgnosticOliveMedium = "hsla(111.4, 3.1%, 55.5%, 0.5)";
export const EcoCssInJsCAgnosticOliveHeavy = "hsla(111.4, 3.1%, 55.5%, 0.7)";
export const EcoCssInJsCAgnosticOliveMajor = "hsla(111.4, 3.1%, 55.5%, 0.85)";
export const EcoCssInJsCAgnosticOliveOpaque = "hsla(111.4, 3.1%, 55.5%, 1)";
export const EcoCssInJsCAgnosticOrangeHsl = "24, 100%, 46.5%";
export const EcoCssInJsCAgnosticOrange = "hsl(24, 100%, 46.5%)";
export const EcoCssInJsCAgnosticOrangeTransparent = "hsla(24, 100%, 46.5%, 0)";
export const EcoCssInJsCAgnosticOrangeMinor = "hsla(24, 100%, 46.5%, 0.15)";
export const EcoCssInJsCAgnosticOrangeWeak = "hsla(24, 100%, 46.5%, 0.3)";
export const EcoCssInJsCAgnosticOrangeMedium = "hsla(24, 100%, 46.5%, 0.5)";
export const EcoCssInJsCAgnosticOrangeHeavy = "hsla(24, 100%, 46.5%, 0.7)";
export const EcoCssInJsCAgnosticOrangeMajor = "hsla(24, 100%, 46.5%, 0.85)";
export const EcoCssInJsCAgnosticOrangeOpaque = "hsla(24, 100%, 46.5%, 1)";
export const EcoCssInJsCAgnosticPinkHsl = "336, 73.7%, 53.5%";
export const EcoCssInJsCAgnosticPink = "hsl(336, 73.7%, 53.5%)";
export const EcoCssInJsCAgnosticPinkTransparent = "hsla(336, 73.7%, 53.5%, 0)";
export const EcoCssInJsCAgnosticPinkMinor = "hsla(336, 73.7%, 53.5%, 0.15)";
export const EcoCssInJsCAgnosticPinkWeak = "hsla(336, 73.7%, 53.5%, 0.3)";
export const EcoCssInJsCAgnosticPinkMedium = "hsla(336, 73.7%, 53.5%, 0.5)";
export const EcoCssInJsCAgnosticPinkHeavy = "hsla(336, 73.7%, 53.5%, 0.7)";
export const EcoCssInJsCAgnosticPinkMajor = "hsla(336, 73.7%, 53.5%, 0.85)";
export const EcoCssInJsCAgnosticPinkOpaque = "hsla(336, 73.7%, 53.5%, 1)";
export const EcoCssInJsCAgnosticPlumHsl = "336, 73.7%, 53.5%";
export const EcoCssInJsCAgnosticPlum = "hsl(336, 73.7%, 53.5%)";
export const EcoCssInJsCAgnosticPlumTransparent = "hsla(336, 73.7%, 53.5%, 0)";
export const EcoCssInJsCAgnosticPlumMinor = "hsla(336, 73.7%, 53.5%, 0.15)";
export const EcoCssInJsCAgnosticPlumWeak = "hsla(336, 73.7%, 53.5%, 0.3)";
export const EcoCssInJsCAgnosticPlumMedium = "hsla(336, 73.7%, 53.5%, 0.5)";
export const EcoCssInJsCAgnosticPlumHeavy = "hsla(336, 73.7%, 53.5%, 0.7)";
export const EcoCssInJsCAgnosticPlumMajor = "hsla(336, 73.7%, 53.5%, 0.85)";
export const EcoCssInJsCAgnosticPlumOpaque = "hsla(336, 73.7%, 53.5%, 1)";
export const EcoCssInJsCAgnosticPurpleHsl = "272, 46.8%, 50.3%";
export const EcoCssInJsCAgnosticPurple = "hsl(272, 46.8%, 50.3%)";
export const EcoCssInJsCAgnosticPurpleTransparent = "hsla(272, 46.8%, 50.3%, 0)";
export const EcoCssInJsCAgnosticPurpleMinor = "hsla(272, 46.8%, 50.3%, 0.15)";
export const EcoCssInJsCAgnosticPurpleWeak = "hsla(272, 46.8%, 50.3%, 0.3)";
export const EcoCssInJsCAgnosticPurpleMedium = "hsla(272, 46.8%, 50.3%, 0.5)";
export const EcoCssInJsCAgnosticPurpleHeavy = "hsla(272, 46.8%, 50.3%, 0.7)";
export const EcoCssInJsCAgnosticPurpleMajor = "hsla(272, 46.8%, 50.3%, 0.85)";
export const EcoCssInJsCAgnosticPurpleOpaque = "hsla(272, 46.8%, 50.3%, 1)";
export const EcoCssInJsCAgnosticRedHsl = "358, 69.4%, 55.2%";
export const EcoCssInJsCAgnosticRed = "hsl(358, 69.4%, 55.2%)";
export const EcoCssInJsCAgnosticRedTransparent = "hsla(358, 69.4%, 55.2%, 0)";
export const EcoCssInJsCAgnosticRedMinor = "hsla(358, 69.4%, 55.2%, 0.15)";
export const EcoCssInJsCAgnosticRedWeak = "hsla(358, 69.4%, 55.2%, 0.3)";
export const EcoCssInJsCAgnosticRedMedium = "hsla(358, 69.4%, 55.2%, 0.5)";
export const EcoCssInJsCAgnosticRedHeavy = "hsla(358, 69.4%, 55.2%, 0.7)";
export const EcoCssInJsCAgnosticRedMajor = "hsla(358, 69.4%, 55.2%, 0.85)";
export const EcoCssInJsCAgnosticRedOpaque = "hsla(358, 69.4%, 55.2%, 1)";
export const EcoCssInJsCAgnosticSageHsl = "154.3, 3.1%, 55.5%";
export const EcoCssInJsCAgnosticSage = "hsl(154.3, 3.1%, 55.5%)";
export const EcoCssInJsCAgnosticSageTransparent = "hsla(154.3, 3.1%, 55.5%, 0)";
export const EcoCssInJsCAgnosticSageMinor = "hsla(154.3, 3.1%, 55.5%, 0.15)";
export const EcoCssInJsCAgnosticSageWeak = "hsla(154.3, 3.1%, 55.5%, 0.3)";
export const EcoCssInJsCAgnosticSageMedium = "hsla(154.3, 3.1%, 55.5%, 0.5)";
export const EcoCssInJsCAgnosticSageHeavy = "hsla(154.3, 3.1%, 55.5%, 0.7)";
export const EcoCssInJsCAgnosticSageMajor = "hsla(154.3, 3.1%, 55.5%, 0.85)";
export const EcoCssInJsCAgnosticSageOpaque = "hsla(154.3, 3.1%, 55.5%, 1)";
export const EcoCssInJsCAgnosticSandHsl = "34.3, 3.1%, 55.5%";
export const EcoCssInJsCAgnosticSand = "hsl(34.3, 3.1%, 55.5%)";
export const EcoCssInJsCAgnosticSandTransparent = "hsla(34.3, 3.1%, 55.5%, 0)";
export const EcoCssInJsCAgnosticSandMinor = "hsla(34.3, 3.1%, 55.5%, 0.15)";
export const EcoCssInJsCAgnosticSandWeak = "hsla(34.3, 3.1%, 55.5%, 0.3)";
export const EcoCssInJsCAgnosticSandMedium = "hsla(34.3, 3.1%, 55.5%, 0.5)";
export const EcoCssInJsCAgnosticSandHeavy = "hsla(34.3, 3.1%, 55.5%, 0.7)";
export const EcoCssInJsCAgnosticSandMajor = "hsla(34.3, 3.1%, 55.5%, 0.85)";
export const EcoCssInJsCAgnosticSandOpaque = "hsla(34.3, 3.1%, 55.5%, 1)";
export const EcoCssInJsCAgnosticSkyHsl = "193, 87%, 66.5%";
export const EcoCssInJsCAgnosticSky = "hsl(193, 87%, 66.5%)";
export const EcoCssInJsCAgnosticSkyTransparent = "hsla(193, 87%, 66.5%, 0)";
export const EcoCssInJsCAgnosticSkyMinor = "hsla(193, 87%, 66.5%, 0.15)";
export const EcoCssInJsCAgnosticSkyWeak = "hsla(193, 87%, 66.5%, 0.3)";
export const EcoCssInJsCAgnosticSkyMedium = "hsla(193, 87%, 66.5%, 0.5)";
export const EcoCssInJsCAgnosticSkyHeavy = "hsla(193, 87%, 66.5%, 0.7)";
export const EcoCssInJsCAgnosticSkyMajor = "hsla(193, 87%, 66.5%, 0.85)";
export const EcoCssInJsCAgnosticSkyOpaque = "hsla(193, 87%, 66.5%, 1)";
export const EcoCssInJsCAgnosticSlateHsl = "205.7, 6.3%, 56.1%";
export const EcoCssInJsCAgnosticSlate = "hsl(205.7, 6.3%, 56.1%)";
export const EcoCssInJsCAgnosticSlateTransparent = "hsla(205.7, 6.3%, 56.1%, 0)";
export const EcoCssInJsCAgnosticSlateMinor = "hsla(205.7, 6.3%, 56.1%, 0.15)";
export const EcoCssInJsCAgnosticSlateWeak = "hsla(205.7, 6.3%, 56.1%, 0.3)";
export const EcoCssInJsCAgnosticSlateMedium = "hsla(205.7, 6.3%, 56.1%, 0.5)";
export const EcoCssInJsCAgnosticSlateHeavy = "hsla(205.7, 6.3%, 56.1%, 0.7)";
export const EcoCssInJsCAgnosticSlateMajor = "hsla(205.7, 6.3%, 56.1%, 0.85)";
export const EcoCssInJsCAgnosticSlateOpaque = "hsla(205.7, 6.3%, 56.1%, 1)";
export const EcoCssInJsCAgnosticTealHsl = "173, 83.4%, 32.5%";
export const EcoCssInJsCAgnosticTeal = "hsl(173, 83.4%, 32.5%)";
export const EcoCssInJsCAgnosticTealTransparent = "hsla(173, 83.4%, 32.5%, 0)";
export const EcoCssInJsCAgnosticTealMinor = "hsla(173, 83.4%, 32.5%, 0.15)";
export const EcoCssInJsCAgnosticTealWeak = "hsla(173, 83.4%, 32.5%, 0.3)";
export const EcoCssInJsCAgnosticTealMedium = "hsla(173, 83.4%, 32.5%, 0.5)";
export const EcoCssInJsCAgnosticTealHeavy = "hsla(173, 83.4%, 32.5%, 0.7)";
export const EcoCssInJsCAgnosticTealMajor = "hsla(173, 83.4%, 32.5%, 0.85)";
export const EcoCssInJsCAgnosticTealOpaque = "hsla(173, 83.4%, 32.5%, 1)";
export const EcoCssInJsCAgnosticTomatoHsl = "10, 71.5%, 50%";
export const EcoCssInJsCAgnosticTomato = "hsl(10, 71.5%, 50%)";
export const EcoCssInJsCAgnosticTomatoTransparent = "hsla(10, 71.5%, 50%, 0)";
export const EcoCssInJsCAgnosticTomatoMinor = "hsla(10, 71.5%, 50%, 0.15)";
export const EcoCssInJsCAgnosticTomatoWeak = "hsla(10, 71.5%, 50%, 0.3)";
export const EcoCssInJsCAgnosticTomatoMedium = "hsla(10, 71.5%, 50%, 0.5)";
export const EcoCssInJsCAgnosticTomatoHeavy = "hsla(10, 71.5%, 50%, 0.7)";
export const EcoCssInJsCAgnosticTomatoMajor = "hsla(10, 71.5%, 50%, 0.85)";
export const EcoCssInJsCAgnosticTomatoOpaque = "hsla(10, 71.5%, 50%, 1)";
export const EcoCssInJsCAgnosticVioletHsl = "251, 48.1%, 53.5%";
export const EcoCssInJsCAgnosticViolet = "hsl(251, 48.1%, 53.5%)";
export const EcoCssInJsCAgnosticVioletTransparent = "hsla(251, 48.1%, 53.5%, 0)";
export const EcoCssInJsCAgnosticVioletMinor = "hsla(251, 48.1%, 53.5%, 0.15)";
export const EcoCssInJsCAgnosticVioletWeak = "hsla(251, 48.1%, 53.5%, 0.3)";
export const EcoCssInJsCAgnosticVioletMedium = "hsla(251, 48.1%, 53.5%, 0.5)";
export const EcoCssInJsCAgnosticVioletHeavy = "hsla(251, 48.1%, 53.5%, 0.7)";
export const EcoCssInJsCAgnosticVioletMajor = "hsla(251, 48.1%, 53.5%, 0.85)";
export const EcoCssInJsCAgnosticVioletOpaque = "hsla(251, 48.1%, 53.5%, 1)";
export const EcoCssInJsCAgnosticWhiteHsl = "0, 100%, 100%";
export const EcoCssInJsCAgnosticWhite = "hsl(0, 100%, 100%)";
export const EcoCssInJsCAgnosticWhiteTransparent = "hsla(0, 100%, 100%, 0)";
export const EcoCssInJsCAgnosticWhiteMinor = "hsla(0, 100%, 100%, 0.15)";
export const EcoCssInJsCAgnosticWhiteWeak = "hsla(0, 100%, 100%, 0.3)";
export const EcoCssInJsCAgnosticWhiteMedium = "hsla(0, 100%, 100%, 0.5)";
export const EcoCssInJsCAgnosticWhiteHeavy = "hsla(0, 100%, 100%, 0.7)";
export const EcoCssInJsCAgnosticWhiteMajor = "hsla(0, 100%, 100%, 0.85)";
export const EcoCssInJsCAgnosticWhiteOpaque = "hsla(0, 100%, 100%, 1)";
export const EcoCssInJsCAgnosticYellowHsl = "50, 100%, 48.5%";
export const EcoCssInJsCAgnosticYellow = "hsl(50, 100%, 48.5%)";
export const EcoCssInJsCAgnosticYellowTransparent = "hsla(50, 100%, 48.5%, 0)";
export const EcoCssInJsCAgnosticYellowMinor = "hsla(50, 100%, 48.5%, 0.15)";
export const EcoCssInJsCAgnosticYellowWeak = "hsla(50, 100%, 48.5%, 0.3)";
export const EcoCssInJsCAgnosticYellowMedium = "hsla(50, 100%, 48.5%, 0.5)";
export const EcoCssInJsCAgnosticYellowHeavy = "hsla(50, 100%, 48.5%, 0.7)";
export const EcoCssInJsCAgnosticYellowMajor = "hsla(50, 100%, 48.5%, 0.85)";
export const EcoCssInJsCAgnosticYellowOpaque = "hsla(50, 100%, 48.5%, 1)";
export const EcoCssInJsCBackground = "hsl(var(--c-background-hsl))";
export const EcoCssInJsCOverlay = "hsla(var(--c-overlay-hsl))";
export const EcoCssInJsCNavBackground = "hsl(var(--c-nav-background-hsl))";
export const EcoCssInJsCCardBackground = "hsl(var(--c-card-background-hsl))";
export const EcoCssInJsCContentBackground = "hsl(var(--c-content-background-hsl))";
export const EcoCssInJsCTableBackground = "hsl(var(--c-table-background-hsl))";
export const EcoCssInJsCCtaBackground = "hsl(var(--hue-sat), 99%)";
export const EcoCssInJsCBackgroundHsl = "var(--hue-sat), 98%";
export const EcoCssInJsCOverlayHsl = "var(--igs-melanin-hsl), 0.88";
export const EcoCssInJsCNavBackgroundHsl = "var(--igs-deep-blue-hsl)";
export const EcoCssInJsCCardBackgroundHsl = "var(--hue-sat), 100%";
export const EcoCssInJsCContentBackgroundHsl = "var(--hue-sat), 100%";
export const EcoCssInJsCTableBackgroundHsl = "var(--hue-sat), 100%";
export const EcoCssInJsCCtaBackgroundHsl = "var(--hue-sat), 99%";
export const EcoCssInJsCBorderBaseHsl = "var(--hue-sat), 80%";
export const EcoCssInJsCBorderWeakHsl = "var(--hue-sat), 95%";
export const EcoCssInJsCBorderStrongHsl = "var(--hue-sat), 65%";
export const EcoCssInJsCBorderBase = "hsl(var(--c-border-base-hsl))";
export const EcoCssInJsCBorderWeak = "hsl(var(--c-border-weak-hsl))";
export const EcoCssInJsCBorderStrong = "hsl(var(--c-border-strong-hsl))";
export const EcoCssInJsCChartHeatmapBlueIndigo = "hsl(var(--c-chart-plot-indigo-hsl))";
export const EcoCssInJsCChartHeatmapBlueDark = "hsl(var(--c-chart-plot-blue-hsl))";
export const EcoCssInJsCChartHeatmapBlueShaded = "hsl(var(--c-chart-plot-light-blue-hsl))";
export const EcoCssInJsCChartHeatmapGreenBright = "hsl(var(--c-chart-plot-green-hsl))";
export const EcoCssInJsCChartHeatmapYellowShaded = "hsl(var(--c-chart-plot-yellow-hsl))";
export const EcoCssInJsCChartHeatmapOrangeShaded = "hsl(var(--c-chart-plot-orange-hsl))";
export const EcoCssInJsCChartHeatmapRedDark = "hsl(var(--c-chart-plot-dark-red-hsl))";
export const EcoCssInJsCChartPlotBlueHsl = "216.76, 100.00%, 40.00%";
export const EcoCssInJsCChartPlotBlue = "hsl(216.76, 100.00%, 40.00%)";
export const EcoCssInJsCChartPlotBlueTransparent = "hsla(216.76, 100.00%, 40.00%, 0)";
export const EcoCssInJsCChartPlotBlueMinor = "hsla(216.76, 100.00%, 40.00%, 0.15)";
export const EcoCssInJsCChartPlotBlueWeak = "hsla(216.76, 100.00%, 40.00%, 0.3)";
export const EcoCssInJsCChartPlotBlueMedium = "hsla(216.76, 100.00%, 40.00%, 0.5)";
export const EcoCssInJsCChartPlotBlueHeavy = "hsla(216.76, 100.00%, 40.00%, 0.7)";
export const EcoCssInJsCChartPlotBlueMajor = "hsla(216.76, 100.00%, 40.00%, 0.85)";
export const EcoCssInJsCChartPlotBlueOpaque = "hsla(216.76, 100.00%, 40.00%, 1)";
export const EcoCssInJsCChartPlotOrangeHsl = "16.47, 100.00%, 40.00%";
export const EcoCssInJsCChartPlotOrange = "hsl(16.47, 100.00%, 40.00%)";
export const EcoCssInJsCChartPlotOrangeTransparent = "hsla(16.47, 100.00%, 40.00%, 0)";
export const EcoCssInJsCChartPlotOrangeMinor = "hsla(16.47, 100.00%, 40.00%, 0.15)";
export const EcoCssInJsCChartPlotOrangeWeak = "hsla(16.47, 100.00%, 40.00%, 0.3)";
export const EcoCssInJsCChartPlotOrangeMedium = "hsla(16.47, 100.00%, 40.00%, 0.5)";
export const EcoCssInJsCChartPlotOrangeHeavy = "hsla(16.47, 100.00%, 40.00%, 0.7)";
export const EcoCssInJsCChartPlotOrangeMajor = "hsla(16.47, 100.00%, 40.00%, 0.85)";
export const EcoCssInJsCChartPlotOrangeOpaque = "hsla(16.47, 100.00%, 40.00%, 1)";
export const EcoCssInJsCChartPlotGreenHsl = "110.88, 100.00%, 40.00%";
export const EcoCssInJsCChartPlotGreen = "hsl(110.88, 100.00%, 40.00%)";
export const EcoCssInJsCChartPlotGreenTransparent = "hsla(110.88, 100.00%, 40.00%, 0)";
export const EcoCssInJsCChartPlotGreenMinor = "hsla(110.88, 100.00%, 40.00%, 0.15)";
export const EcoCssInJsCChartPlotGreenWeak = "hsla(110.88, 100.00%, 40.00%, 0.3)";
export const EcoCssInJsCChartPlotGreenMedium = "hsla(110.88, 100.00%, 40.00%, 0.5)";
export const EcoCssInJsCChartPlotGreenHeavy = "hsla(110.88, 100.00%, 40.00%, 0.7)";
export const EcoCssInJsCChartPlotGreenMajor = "hsla(110.88, 100.00%, 40.00%, 0.85)";
export const EcoCssInJsCChartPlotGreenOpaque = "hsla(110.88, 100.00%, 40.00%, 1)";
export const EcoCssInJsCChartPlotYellowHsl = "45.90, 100.00%, 45.88%";
export const EcoCssInJsCChartPlotYellow = "hsl(45.90, 100.00%, 45.88%)";
export const EcoCssInJsCChartPlotYellowTransparent = "hsla(45.90, 100.00%, 45.88%, 0)";
export const EcoCssInJsCChartPlotYellowMinor = "hsla(45.90, 100.00%, 45.88%, 0.15)";
export const EcoCssInJsCChartPlotYellowWeak = "hsla(45.90, 100.00%, 45.88%, 0.3)";
export const EcoCssInJsCChartPlotYellowMedium = "hsla(45.90, 100.00%, 45.88%, 0.5)";
export const EcoCssInJsCChartPlotYellowHeavy = "hsla(45.90, 100.00%, 45.88%, 0.7)";
export const EcoCssInJsCChartPlotYellowMajor = "hsla(45.90, 100.00%, 45.88%, 0.85)";
export const EcoCssInJsCChartPlotYellowOpaque = "hsla(45.90, 100.00%, 45.88%, 1)";
export const EcoCssInJsCChartPlotLightBlueHsl = "190.29, 100.00%, 40.00%";
export const EcoCssInJsCChartPlotLightBlue = "hsl(190.29, 100.00%, 40.00%)";
export const EcoCssInJsCChartPlotLightBlueTransparent = "hsla(190.29, 100.00%, 40.00%, 0)";
export const EcoCssInJsCChartPlotLightBlueMinor = "hsla(190.29, 100.00%, 40.00%, 0.15)";
export const EcoCssInJsCChartPlotLightBlueWeak = "hsla(190.29, 100.00%, 40.00%, 0.3)";
export const EcoCssInJsCChartPlotLightBlueMedium = "hsla(190.29, 100.00%, 40.00%, 0.5)";
export const EcoCssInJsCChartPlotLightBlueHeavy = "hsla(190.29, 100.00%, 40.00%, 0.7)";
export const EcoCssInJsCChartPlotLightBlueMajor = "hsla(190.29, 100.00%, 40.00%, 0.85)";
export const EcoCssInJsCChartPlotLightBlueOpaque = "hsla(190.29, 100.00%, 40.00%, 1)";
export const EcoCssInJsCChartPlotDarkRedHsl = "0.00, 100.00%, 20.00%";
export const EcoCssInJsCChartPlotDarkRed = "hsl(0.00, 100.00%, 20.00%)";
export const EcoCssInJsCChartPlotDarkRedTransparent = "hsla(0.00, 100.00%, 20.00%, 0)";
export const EcoCssInJsCChartPlotDarkRedMinor = "hsla(0.00, 100.00%, 20.00%, 0.15)";
export const EcoCssInJsCChartPlotDarkRedWeak = "hsla(0.00, 100.00%, 20.00%, 0.3)";
export const EcoCssInJsCChartPlotDarkRedMedium = "hsla(0.00, 100.00%, 20.00%, 0.5)";
export const EcoCssInJsCChartPlotDarkRedHeavy = "hsla(0.00, 100.00%, 20.00%, 0.7)";
export const EcoCssInJsCChartPlotDarkRedMajor = "hsla(0.00, 100.00%, 20.00%, 0.85)";
export const EcoCssInJsCChartPlotDarkRedOpaque = "hsla(0.00, 100.00%, 20.00%, 1)";
export const EcoCssInJsCChartPlotIndigoHsl = "240.00, 100.00%, 20.00%";
export const EcoCssInJsCChartPlotIndigo = "hsl(240.00, 100.00%, 20.00%)";
export const EcoCssInJsCChartPlotIndigoTransparent = "hsla(240.00, 100.00%, 20.00%, 0)";
export const EcoCssInJsCChartPlotIndigoMinor = "hsla(240.00, 100.00%, 20.00%, 0.15)";
export const EcoCssInJsCChartPlotIndigoWeak = "hsla(240.00, 100.00%, 20.00%, 0.3)";
export const EcoCssInJsCChartPlotIndigoMedium = "hsla(240.00, 100.00%, 20.00%, 0.5)";
export const EcoCssInJsCChartPlotIndigoHeavy = "hsla(240.00, 100.00%, 20.00%, 0.7)";
export const EcoCssInJsCChartPlotIndigoMajor = "hsla(240.00, 100.00%, 20.00%, 0.85)";
export const EcoCssInJsCChartPlotIndigoOpaque = "hsla(240.00, 100.00%, 20.00%, 1)";
export const EcoCssInJsCChartPlotSpecificCropHeight = "hsl(var(--c-agnostic-grass-hsl))";
export const EcoCssInJsCChartPlotSpecificCropHeightTransparent = "hsla(var(--c-agnostic-grass-hsl), 0)";
export const EcoCssInJsCChartPlotSpecificCropHeightMinor = "hsla(var(--c-agnostic-grass-hsl), 0.15)";
export const EcoCssInJsCChartPlotSpecificCropHeightWeak = "hsla(var(--c-agnostic-grass-hsl), 0.3)";
export const EcoCssInJsCChartPlotSpecificCropHeightMedium = "hsla(var(--c-agnostic-grass-hsl), 0.5)";
export const EcoCssInJsCChartPlotSpecificCropHeightHeavy = "hsla(var(--c-agnostic-grass-hsl), 0.7)";
export const EcoCssInJsCChartPlotSpecificCropHeightMajor = "hsla(var(--c-agnostic-grass-hsl), 0.85)";
export const EcoCssInJsCChartPlotSpecificCropHeightOpaque = "hsla(var(--c-agnostic-grass-hsl), 1)";
export const EcoCssInJsCChartPlotSpecificWaterLevel = "hsl(228.64, 95.65%, 72.94%)";
export const EcoCssInJsCChartPlotSpecificWaterLevelTransparent = "hsla(228.64, 95.65%, 72.94%, 0)";
export const EcoCssInJsCChartPlotSpecificWaterLevelMinor = "hsla(228.64, 95.65%, 72.94%, 0.15)";
export const EcoCssInJsCChartPlotSpecificWaterLevelWeak = "hsla(228.64, 95.65%, 72.94%, 0.3)";
export const EcoCssInJsCChartPlotSpecificWaterLevelMedium = "hsla(228.64, 95.65%, 72.94%, 0.5)";
export const EcoCssInJsCChartPlotSpecificWaterLevelHeavy = "hsla(228.64, 95.65%, 72.94%, 0.7)";
export const EcoCssInJsCChartPlotSpecificWaterLevelMajor = "hsla(228.64, 95.65%, 72.94%, 0.85)";
export const EcoCssInJsCChartPlotSpecificWaterLevelOpaque = "hsla(228.64, 95.65%, 72.94%, 1)";
export const EcoCssInJsCChartPlotSpecificSetpointWarning = "hsl(var(--igs-warning-hsl))";
export const EcoCssInJsCChartPlotSpecificSetpointWarningTransparent = "hsla(var(--igs-warning-hsl), 0)";
export const EcoCssInJsCChartPlotSpecificSetpointWarningMinor = "hsla(var(--igs-warning-hsl), 0.15)";
export const EcoCssInJsCChartPlotSpecificSetpointWarningWeak = "hsla(var(--igs-warning-hsl), 0.3)";
export const EcoCssInJsCChartPlotSpecificSetpointWarningMedium = "hsla(var(--igs-warning-hsl), 0.5)";
export const EcoCssInJsCChartPlotSpecificSetpointWarningHeavy = "hsla(var(--igs-warning-hsl), 0.7)";
export const EcoCssInJsCChartPlotSpecificSetpointWarningMajor = "hsla(var(--igs-warning-hsl), 0.85)";
export const EcoCssInJsCChartPlotSpecificSetpointWarningOpaque = "hsla(var(--igs-warning-hsl), 1)";
export const EcoCssInJsCChartPlotSpecificActualLight = "hsl(var(--c-agnostic-yellow-hsl))";
export const EcoCssInJsCChartPlotSpecificActualLightTransparent = "hsla(var(--c-agnostic-yellow-hsl), 0)";
export const EcoCssInJsCChartPlotSpecificActualLightMinor = "hsla(var(--c-agnostic-yellow-hsl), 0.15)";
export const EcoCssInJsCChartPlotSpecificActualLightWeak = "hsla(var(--c-agnostic-yellow-hsl), 0.3)";
export const EcoCssInJsCChartPlotSpecificActualLightMedium = "hsla(var(--c-agnostic-yellow-hsl), 0.5)";
export const EcoCssInJsCChartPlotSpecificActualLightHeavy = "hsla(var(--c-agnostic-yellow-hsl), 0.7)";
export const EcoCssInJsCChartPlotSpecificActualLightMajor = "hsla(var(--c-agnostic-yellow-hsl), 0.85)";
export const EcoCssInJsCChartPlotSpecificActualLightOpaque = "hsla(var(--c-agnostic-yellow-hsl), 1)";
export const EcoCssInJsCChartPlotSpecificExpectedLight = "hsl(var(--c-agnostic-gray-hsl))";
export const EcoCssInJsCChartPlotSpecificExpectedLightTransparent = "hsla(var(--c-agnostic-gray-hsl), 0)";
export const EcoCssInJsCChartPlotSpecificExpectedLightMinor = "hsla(var(--c-agnostic-gray-hsl), 0.15)";
export const EcoCssInJsCChartPlotSpecificExpectedLightWeak = "hsla(var(--c-agnostic-gray-hsl), 0.3)";
export const EcoCssInJsCChartPlotSpecificExpectedLightMedium = "hsla(var(--c-agnostic-gray-hsl), 0.5)";
export const EcoCssInJsCChartPlotSpecificExpectedLightHeavy = "hsla(var(--c-agnostic-gray-hsl), 0.7)";
export const EcoCssInJsCChartPlotSpecificExpectedLightMajor = "hsla(var(--c-agnostic-gray-hsl), 0.85)";
export const EcoCssInJsCChartPlotSpecificExpectedLightOpaque = "hsla(var(--c-agnostic-gray-hsl), 1)";
export const EcoCssInJsCChartPlotSpecificDeviationLight = "hsl(var(--c-agnostic-amber-hsl))";
export const EcoCssInJsCChartPlotSpecificDeviationLightTransparent = "hsla(var(--c-agnostic-amber-hsl), 0)";
export const EcoCssInJsCChartPlotSpecificDeviationLightMinor = "hsla(var(--c-agnostic-amber-hsl), 0.15)";
export const EcoCssInJsCChartPlotSpecificDeviationLightWeak = "hsla(var(--c-agnostic-amber-hsl), 0.3)";
export const EcoCssInJsCChartPlotSpecificDeviationLightMedium = "hsla(var(--c-agnostic-amber-hsl), 0.5)";
export const EcoCssInJsCChartPlotSpecificDeviationLightHeavy = "hsla(var(--c-agnostic-amber-hsl), 0.7)";
export const EcoCssInJsCChartPlotSpecificDeviationLightMajor = "hsla(var(--c-agnostic-amber-hsl), 0.85)";
export const EcoCssInJsCChartPlotSpecificDeviationLightOpaque = "hsla(var(--c-agnostic-amber-hsl), 1)";
export const EcoCssInJsCChartTextTitle = "var(--c-text)";
export const EcoCssInJsCChartTextLabel = "var(--c-text-secondary)";
export const EcoCssInJsCCmdStateScheduledHsl = "var(--c-agnostic-lime-hsl)";
export const EcoCssInJsCCmdStateScheduled = "hsl(var(--c-agnostic-lime-hsl))";
export const EcoCssInJsCCmdStateScheduledTransparent = "hsla(var(--c-agnostic-lime-hsl), 0)";
export const EcoCssInJsCCmdStateScheduledMinor = "hsla(var(--c-agnostic-lime-hsl), 0.15)";
export const EcoCssInJsCCmdStateScheduledWeak = "hsla(var(--c-agnostic-lime-hsl), 0.3)";
export const EcoCssInJsCCmdStateScheduledMedium = "hsla(var(--c-agnostic-lime-hsl), 0.5)";
export const EcoCssInJsCCmdStateScheduledHeavy = "hsla(var(--c-agnostic-lime-hsl), 0.7)";
export const EcoCssInJsCCmdStateScheduledMajor = "hsla(var(--c-agnostic-lime-hsl), 0.85)";
export const EcoCssInJsCCmdStateScheduledOpaque = "hsla(var(--c-agnostic-lime-hsl), 1)";
export const EcoCssInJsCCmdStateRunningHsl = "var(--c-agnostic-blue-hsl)";
export const EcoCssInJsCCmdStateRunning = "hsl(var(--c-agnostic-blue-hsl))";
export const EcoCssInJsCCmdStateRunningTransparent = "hsla(var(--c-agnostic-blue-hsl), 0)";
export const EcoCssInJsCCmdStateRunningMinor = "hsla(var(--c-agnostic-blue-hsl), 0.15)";
export const EcoCssInJsCCmdStateRunningWeak = "hsla(var(--c-agnostic-blue-hsl), 0.3)";
export const EcoCssInJsCCmdStateRunningMedium = "hsla(var(--c-agnostic-blue-hsl), 0.5)";
export const EcoCssInJsCCmdStateRunningHeavy = "hsla(var(--c-agnostic-blue-hsl), 0.7)";
export const EcoCssInJsCCmdStateRunningMajor = "hsla(var(--c-agnostic-blue-hsl), 0.85)";
export const EcoCssInJsCCmdStateRunningOpaque = "hsla(var(--c-agnostic-blue-hsl), 1)";
export const EcoCssInJsCCmdStateFinishedHsl = "var(--c-cta-success-hsl)";
export const EcoCssInJsCCmdStateFinished = "hsl(var(--c-cta-success-hsl))";
export const EcoCssInJsCCmdStateFinishedTransparent = "hsla(var(--c-cta-success-hsl), 0)";
export const EcoCssInJsCCmdStateFinishedMinor = "hsla(var(--c-cta-success-hsl), 0.15)";
export const EcoCssInJsCCmdStateFinishedWeak = "hsla(var(--c-cta-success-hsl), 0.3)";
export const EcoCssInJsCCmdStateFinishedMedium = "hsla(var(--c-cta-success-hsl), 0.5)";
export const EcoCssInJsCCmdStateFinishedHeavy = "hsla(var(--c-cta-success-hsl), 0.7)";
export const EcoCssInJsCCmdStateFinishedMajor = "hsla(var(--c-cta-success-hsl), 0.85)";
export const EcoCssInJsCCmdStateFinishedOpaque = "hsla(var(--c-cta-success-hsl), 1)";
export const EcoCssInJsCCmdStateCancelledHsl = "var(--c-agnostic-yellow-hsl)";
export const EcoCssInJsCCmdStateCancelled = "hsl(var(--c-agnostic-yellow-hsl))";
export const EcoCssInJsCCmdStateCancelledTransparent = "hsla(var(--c-agnostic-yellow-hsl), 0)";
export const EcoCssInJsCCmdStateCancelledMinor = "hsla(var(--c-agnostic-yellow-hsl), 0.15)";
export const EcoCssInJsCCmdStateCancelledWeak = "hsla(var(--c-agnostic-yellow-hsl), 0.3)";
export const EcoCssInJsCCmdStateCancelledMedium = "hsla(var(--c-agnostic-yellow-hsl), 0.5)";
export const EcoCssInJsCCmdStateCancelledHeavy = "hsla(var(--c-agnostic-yellow-hsl), 0.7)";
export const EcoCssInJsCCmdStateCancelledMajor = "hsla(var(--c-agnostic-yellow-hsl), 0.85)";
export const EcoCssInJsCCmdStateCancelledOpaque = "hsla(var(--c-agnostic-yellow-hsl), 1)";
export const EcoCssInJsCCmdStateSkippedHsl = "var(--c-agnostic-mauve-hsl)";
export const EcoCssInJsCCmdStateSkipped = "hsl(var(--c-agnostic-mauve-hsl))";
export const EcoCssInJsCCmdStateSkippedTransparent = "hsla(var(--c-agnostic-mauve-hsl), 0)";
export const EcoCssInJsCCmdStateSkippedMinor = "hsla(var(--c-agnostic-mauve-hsl), 0.15)";
export const EcoCssInJsCCmdStateSkippedWeak = "hsla(var(--c-agnostic-mauve-hsl), 0.3)";
export const EcoCssInJsCCmdStateSkippedMedium = "hsla(var(--c-agnostic-mauve-hsl), 0.5)";
export const EcoCssInJsCCmdStateSkippedHeavy = "hsla(var(--c-agnostic-mauve-hsl), 0.7)";
export const EcoCssInJsCCmdStateSkippedMajor = "hsla(var(--c-agnostic-mauve-hsl), 0.85)";
export const EcoCssInJsCCmdStateSkippedOpaque = "hsla(var(--c-agnostic-mauve-hsl), 1)";
export const EcoCssInJsCCmdStateDelayedHsl = "var(--c-cta-warning-hsl)";
export const EcoCssInJsCCmdStateDelayed = "hsl(var(--c-cta-warning-hsl))";
export const EcoCssInJsCCmdStateDelayedTransparent = "hsla(var(--c-cta-warning-hsl), 0)";
export const EcoCssInJsCCmdStateDelayedMinor = "hsla(var(--c-cta-warning-hsl), 0.15)";
export const EcoCssInJsCCmdStateDelayedWeak = "hsla(var(--c-cta-warning-hsl), 0.3)";
export const EcoCssInJsCCmdStateDelayedMedium = "hsla(var(--c-cta-warning-hsl), 0.5)";
export const EcoCssInJsCCmdStateDelayedHeavy = "hsla(var(--c-cta-warning-hsl), 0.7)";
export const EcoCssInJsCCmdStateDelayedMajor = "hsla(var(--c-cta-warning-hsl), 0.85)";
export const EcoCssInJsCCmdStateDelayedOpaque = "hsla(var(--c-cta-warning-hsl), 1)";
export const EcoCssInJsCCmdStateFailedHsl = "var(--c-cta-danger-hsl)";
export const EcoCssInJsCCmdStateFailed = "hsl(var(--c-cta-danger-hsl))";
export const EcoCssInJsCCmdStateFailedTransparent = "hsla(var(--c-cta-danger-hsl), 0)";
export const EcoCssInJsCCmdStateFailedMinor = "hsla(var(--c-cta-danger-hsl), 0.15)";
export const EcoCssInJsCCmdStateFailedWeak = "hsla(var(--c-cta-danger-hsl), 0.3)";
export const EcoCssInJsCCmdStateFailedMedium = "hsla(var(--c-cta-danger-hsl), 0.5)";
export const EcoCssInJsCCmdStateFailedHeavy = "hsla(var(--c-cta-danger-hsl), 0.7)";
export const EcoCssInJsCCmdStateFailedMajor = "hsla(var(--c-cta-danger-hsl), 0.85)";
export const EcoCssInJsCCmdStateFailedOpaque = "hsla(var(--c-cta-danger-hsl), 1)";
export const EcoCssInJsCCmdStateActiveHsl = "var(--c-cta-info-hsl)";
export const EcoCssInJsCCmdStateActive = "hsl(var(--c-cta-info-hsl))";
export const EcoCssInJsCCmdStateActiveTransparent = "hsla(var(--c-cta-info-hsl), 0)";
export const EcoCssInJsCCmdStateActiveMinor = "hsla(var(--c-cta-info-hsl), 0.15)";
export const EcoCssInJsCCmdStateActiveWeak = "hsla(var(--c-cta-info-hsl), 0.3)";
export const EcoCssInJsCCmdStateActiveMedium = "hsla(var(--c-cta-info-hsl), 0.5)";
export const EcoCssInJsCCmdStateActiveHeavy = "hsla(var(--c-cta-info-hsl), 0.7)";
export const EcoCssInJsCCmdStateActiveMajor = "hsla(var(--c-cta-info-hsl), 0.85)";
export const EcoCssInJsCCmdStateActiveOpaque = "hsla(var(--c-cta-info-hsl), 1)";
export const EcoCssInJsCCodeText = "hsl(var(--hue-sat), 6%)";
export const EcoCssInJsCCodeBorder = "hsl(var(--hue-sat), 85%)";
export const EcoCssInJsCCodeBackground = "hsla(var(--hue-sat), 92%, var(--alpha-major))";
export const EcoCssInJsCCtaDefaultHsl = "var(--igs-dark-turquoise-h), 100%, 26%";
export const EcoCssInJsCCtaDefault = "hsl(var(--igs-dark-turquoise-h), 100%, 26%)";
export const EcoCssInJsCCtaDefaultTransparent = "hsla(var(--igs-dark-turquoise-h), 100%, 26%, 0)";
export const EcoCssInJsCCtaDefaultMinor = "hsla(var(--igs-dark-turquoise-h), 100%, 26%, 0.15)";
export const EcoCssInJsCCtaDefaultWeak = "hsla(var(--igs-dark-turquoise-h), 100%, 26%, 0.3)";
export const EcoCssInJsCCtaDefaultMedium = "hsla(var(--igs-dark-turquoise-h), 100%, 26%, 0.5)";
export const EcoCssInJsCCtaDefaultHeavy = "hsla(var(--igs-dark-turquoise-h), 100%, 26%, 0.7)";
export const EcoCssInJsCCtaDefaultMajor = "hsla(var(--igs-dark-turquoise-h), 100%, 26%, 0.85)";
export const EcoCssInJsCCtaDefaultOpaque = "hsla(var(--igs-dark-turquoise-h), 100%, 26%, 1)";
export const EcoCssInJsCCtaInfoHsl = "var(--igs-blue-hsl)";
export const EcoCssInJsCCtaInfo = "hsl(var(--igs-blue-hsl))";
export const EcoCssInJsCCtaInfoTransparent = "hsla(var(--igs-blue-hsl), 0)";
export const EcoCssInJsCCtaInfoMinor = "hsla(var(--igs-blue-hsl), 0.15)";
export const EcoCssInJsCCtaInfoWeak = "hsla(var(--igs-blue-hsl), 0.3)";
export const EcoCssInJsCCtaInfoMedium = "hsla(var(--igs-blue-hsl), 0.5)";
export const EcoCssInJsCCtaInfoHeavy = "hsla(var(--igs-blue-hsl), 0.7)";
export const EcoCssInJsCCtaInfoMajor = "hsla(var(--igs-blue-hsl), 0.85)";
export const EcoCssInJsCCtaInfoOpaque = "hsla(var(--igs-blue-hsl), 1)";
export const EcoCssInJsCCtaSuccessHsl = "var(--igs-success-hsl)";
export const EcoCssInJsCCtaSuccess = "hsl(var(--igs-success-hsl))";
export const EcoCssInJsCCtaSuccessTransparent = "hsla(var(--igs-success-hsl), 0)";
export const EcoCssInJsCCtaSuccessMinor = "hsla(var(--igs-success-hsl), 0.15)";
export const EcoCssInJsCCtaSuccessWeak = "hsla(var(--igs-success-hsl), 0.3)";
export const EcoCssInJsCCtaSuccessMedium = "hsla(var(--igs-success-hsl), 0.5)";
export const EcoCssInJsCCtaSuccessHeavy = "hsla(var(--igs-success-hsl), 0.7)";
export const EcoCssInJsCCtaSuccessMajor = "hsla(var(--igs-success-hsl), 0.85)";
export const EcoCssInJsCCtaSuccessOpaque = "hsla(var(--igs-success-hsl), 1)";
export const EcoCssInJsCCtaDangerHsl = "var(--igs-danger-hsl)";
export const EcoCssInJsCCtaDanger = "hsl(var(--igs-danger-hsl))";
export const EcoCssInJsCCtaDangerTransparent = "hsla(var(--igs-danger-hsl), 0)";
export const EcoCssInJsCCtaDangerMinor = "hsla(var(--igs-danger-hsl), 0.15)";
export const EcoCssInJsCCtaDangerWeak = "hsla(var(--igs-danger-hsl), 0.3)";
export const EcoCssInJsCCtaDangerMedium = "hsla(var(--igs-danger-hsl), 0.5)";
export const EcoCssInJsCCtaDangerHeavy = "hsla(var(--igs-danger-hsl), 0.7)";
export const EcoCssInJsCCtaDangerMajor = "hsla(var(--igs-danger-hsl), 0.85)";
export const EcoCssInJsCCtaDangerOpaque = "hsla(var(--igs-danger-hsl), 1)";
export const EcoCssInJsCCtaWarningHsl = "var(--igs-warning-hsl)";
export const EcoCssInJsCCtaWarning = "hsl(var(--igs-warning-hsl))";
export const EcoCssInJsCCtaWarningTransparent = "hsla(var(--igs-warning-hsl), 0)";
export const EcoCssInJsCCtaWarningMinor = "hsla(var(--igs-warning-hsl), 0.15)";
export const EcoCssInJsCCtaWarningWeak = "hsla(var(--igs-warning-hsl), 0.3)";
export const EcoCssInJsCCtaWarningMedium = "hsla(var(--igs-warning-hsl), 0.5)";
export const EcoCssInJsCCtaWarningHeavy = "hsla(var(--igs-warning-hsl), 0.7)";
export const EcoCssInJsCCtaWarningMajor = "hsla(var(--igs-warning-hsl), 0.85)";
export const EcoCssInJsCCtaWarningOpaque = "hsla(var(--igs-warning-hsl), 1)";
export const EcoCssInJsCInputDisabled = "hsl(var(--igs-deep-blue-h), 0%, 90%)";
export const EcoCssInJsCJobStateScheduledHsl = "var(--c-agnostic-lime-hsl)";
export const EcoCssInJsCJobStateScheduled = "hsl(var(--c-agnostic-lime-hsl))";
export const EcoCssInJsCJobStateScheduledTransparent = "hsla(var(--c-agnostic-lime-hsl), 0)";
export const EcoCssInJsCJobStateScheduledMinor = "hsla(var(--c-agnostic-lime-hsl), 0.15)";
export const EcoCssInJsCJobStateScheduledWeak = "hsla(var(--c-agnostic-lime-hsl), 0.3)";
export const EcoCssInJsCJobStateScheduledMedium = "hsla(var(--c-agnostic-lime-hsl), 0.5)";
export const EcoCssInJsCJobStateScheduledHeavy = "hsla(var(--c-agnostic-lime-hsl), 0.7)";
export const EcoCssInJsCJobStateScheduledMajor = "hsla(var(--c-agnostic-lime-hsl), 0.85)";
export const EcoCssInJsCJobStateScheduledOpaque = "hsla(var(--c-agnostic-lime-hsl), 1)";
export const EcoCssInJsCJobStateRunningHsl = "var(--c-agnostic-blue-hsl)";
export const EcoCssInJsCJobStateRunning = "hsl(var(--c-agnostic-blue-hsl))";
export const EcoCssInJsCJobStateRunningTransparent = "hsla(var(--c-agnostic-blue-hsl), 0)";
export const EcoCssInJsCJobStateRunningMinor = "hsla(var(--c-agnostic-blue-hsl), 0.15)";
export const EcoCssInJsCJobStateRunningWeak = "hsla(var(--c-agnostic-blue-hsl), 0.3)";
export const EcoCssInJsCJobStateRunningMedium = "hsla(var(--c-agnostic-blue-hsl), 0.5)";
export const EcoCssInJsCJobStateRunningHeavy = "hsla(var(--c-agnostic-blue-hsl), 0.7)";
export const EcoCssInJsCJobStateRunningMajor = "hsla(var(--c-agnostic-blue-hsl), 0.85)";
export const EcoCssInJsCJobStateRunningOpaque = "hsla(var(--c-agnostic-blue-hsl), 1)";
export const EcoCssInJsCJobStateFinishedHsl = "var(--c-cta-danger-hsl)";
export const EcoCssInJsCJobStateFinished = "hsl(var(--c-cta-danger-hsl))";
export const EcoCssInJsCJobStateFinishedTransparent = "hsla(var(--c-cta-danger-hsl), 0)";
export const EcoCssInJsCJobStateFinishedMinor = "hsla(var(--c-cta-danger-hsl), 0.15)";
export const EcoCssInJsCJobStateFinishedWeak = "hsla(var(--c-cta-danger-hsl), 0.3)";
export const EcoCssInJsCJobStateFinishedMedium = "hsla(var(--c-cta-danger-hsl), 0.5)";
export const EcoCssInJsCJobStateFinishedHeavy = "hsla(var(--c-cta-danger-hsl), 0.7)";
export const EcoCssInJsCJobStateFinishedMajor = "hsla(var(--c-cta-danger-hsl), 0.85)";
export const EcoCssInJsCJobStateFinishedOpaque = "hsla(var(--c-cta-danger-hsl), 1)";
export const EcoCssInJsCJobStateCancelledHsl = "var(--c-agnostic-slate-hsl)";
export const EcoCssInJsCJobStateCancelled = "hsl(var(--c-agnostic-slate-hsl))";
export const EcoCssInJsCJobStateCancelledTransparent = "hsla(var(--c-agnostic-slate-hsl), 0)";
export const EcoCssInJsCJobStateCancelledMinor = "hsla(var(--c-agnostic-slate-hsl), 0.15)";
export const EcoCssInJsCJobStateCancelledWeak = "hsla(var(--c-agnostic-slate-hsl), 0.3)";
export const EcoCssInJsCJobStateCancelledMedium = "hsla(var(--c-agnostic-slate-hsl), 0.5)";
export const EcoCssInJsCJobStateCancelledHeavy = "hsla(var(--c-agnostic-slate-hsl), 0.7)";
export const EcoCssInJsCJobStateCancelledMajor = "hsla(var(--c-agnostic-slate-hsl), 0.85)";
export const EcoCssInJsCJobStateCancelledOpaque = "hsla(var(--c-agnostic-slate-hsl), 1)";
export const EcoCssInJsCJobStateHarvestedHsl = "var(--c-cta-success-hsl)";
export const EcoCssInJsCJobStateHarvested = "hsl(var(--c-cta-success-hsl))";
export const EcoCssInJsCJobStateHarvestedTransparent = "hsla(var(--c-cta-success-hsl), 0)";
export const EcoCssInJsCJobStateHarvestedMinor = "hsla(var(--c-cta-success-hsl), 0.15)";
export const EcoCssInJsCJobStateHarvestedWeak = "hsla(var(--c-cta-success-hsl), 0.3)";
export const EcoCssInJsCJobStateHarvestedMedium = "hsla(var(--c-cta-success-hsl), 0.5)";
export const EcoCssInJsCJobStateHarvestedHeavy = "hsla(var(--c-cta-success-hsl), 0.7)";
export const EcoCssInJsCJobStateHarvestedMajor = "hsla(var(--c-cta-success-hsl), 0.85)";
export const EcoCssInJsCJobStateHarvestedOpaque = "hsla(var(--c-cta-success-hsl), 1)";
export const EcoCssInJsCJobStateReadyForHarvestHsl = "var(--c-cta-warning-hsl)";
export const EcoCssInJsCJobStateReadyForHarvest = "hsl(var(--c-cta-warning-hsl))";
export const EcoCssInJsCJobStateReadyForHarvestTransparent = "hsla(var(--c-cta-warning-hsl), 0)";
export const EcoCssInJsCJobStateReadyForHarvestMinor = "hsla(var(--c-cta-warning-hsl), 0.15)";
export const EcoCssInJsCJobStateReadyForHarvestWeak = "hsla(var(--c-cta-warning-hsl), 0.3)";
export const EcoCssInJsCJobStateReadyForHarvestMedium = "hsla(var(--c-cta-warning-hsl), 0.5)";
export const EcoCssInJsCJobStateReadyForHarvestHeavy = "hsla(var(--c-cta-warning-hsl), 0.7)";
export const EcoCssInJsCJobStateReadyForHarvestMajor = "hsla(var(--c-cta-warning-hsl), 0.85)";
export const EcoCssInJsCJobStateReadyForHarvestOpaque = "hsla(var(--c-cta-warning-hsl), 1)";
export const EcoCssInJsCOperationStateSuccessHsl = "var(--c-cta-success-hsl)";
export const EcoCssInJsCOperationStateSuccess = "hsl(var(--c-cta-success-hsl))";
export const EcoCssInJsCOperationStateSuccessTransparent = "hsla(var(--c-cta-success-hsl), 0)";
export const EcoCssInJsCOperationStateSuccessMinor = "hsla(var(--c-cta-success-hsl), 0.15)";
export const EcoCssInJsCOperationStateSuccessWeak = "hsla(var(--c-cta-success-hsl), 0.3)";
export const EcoCssInJsCOperationStateSuccessMedium = "hsla(var(--c-cta-success-hsl), 0.5)";
export const EcoCssInJsCOperationStateSuccessHeavy = "hsla(var(--c-cta-success-hsl), 0.7)";
export const EcoCssInJsCOperationStateSuccessMajor = "hsla(var(--c-cta-success-hsl), 0.85)";
export const EcoCssInJsCOperationStateSuccessOpaque = "hsla(var(--c-cta-success-hsl), 1)";
export const EcoCssInJsCOperationStateFailHsl = "var(--c-cta-danger-hsl)";
export const EcoCssInJsCOperationStateFail = "hsl(var(--c-cta-danger-hsl))";
export const EcoCssInJsCOperationStateFailTransparent = "hsla(var(--c-cta-danger-hsl), 0)";
export const EcoCssInJsCOperationStateFailMinor = "hsla(var(--c-cta-danger-hsl), 0.15)";
export const EcoCssInJsCOperationStateFailWeak = "hsla(var(--c-cta-danger-hsl), 0.3)";
export const EcoCssInJsCOperationStateFailMedium = "hsla(var(--c-cta-danger-hsl), 0.5)";
export const EcoCssInJsCOperationStateFailHeavy = "hsla(var(--c-cta-danger-hsl), 0.7)";
export const EcoCssInJsCOperationStateFailMajor = "hsla(var(--c-cta-danger-hsl), 0.85)";
export const EcoCssInJsCOperationStateFailOpaque = "hsla(var(--c-cta-danger-hsl), 1)";
export const EcoCssInJsCOperationStatePendingHsl = "var(--hue-sat), 66%";
export const EcoCssInJsCOperationStatePending = "hsl(var(--hue-sat), 66%)";
export const EcoCssInJsCOperationStatePendingTransparent = "hsla(var(--hue-sat), 66%, 0)";
export const EcoCssInJsCOperationStatePendingMinor = "hsla(var(--hue-sat), 66%, 0.15)";
export const EcoCssInJsCOperationStatePendingWeak = "hsla(var(--hue-sat), 66%, 0.3)";
export const EcoCssInJsCOperationStatePendingMedium = "hsla(var(--hue-sat), 66%, 0.5)";
export const EcoCssInJsCOperationStatePendingHeavy = "hsla(var(--hue-sat), 66%, 0.7)";
export const EcoCssInJsCOperationStatePendingMajor = "hsla(var(--hue-sat), 66%, 0.85)";
export const EcoCssInJsCOperationStatePendingOpaque = "hsla(var(--hue-sat), 66%, 1)";
export const EcoCssInJsCOperationTypeLightHsl = "var(--c-agnostic-yellow-hsl)";
export const EcoCssInJsCOperationTypeLight = "hsl(var(--c-agnostic-yellow-hsl))";
export const EcoCssInJsCOperationTypeLightTransparent = "hsla(var(--c-agnostic-yellow-hsl), 0)";
export const EcoCssInJsCOperationTypeLightMinor = "hsla(var(--c-agnostic-yellow-hsl), 0.15)";
export const EcoCssInJsCOperationTypeLightWeak = "hsla(var(--c-agnostic-yellow-hsl), 0.3)";
export const EcoCssInJsCOperationTypeLightMedium = "hsla(var(--c-agnostic-yellow-hsl), 0.5)";
export const EcoCssInJsCOperationTypeLightHeavy = "hsla(var(--c-agnostic-yellow-hsl), 0.7)";
export const EcoCssInJsCOperationTypeLightMajor = "hsla(var(--c-agnostic-yellow-hsl), 0.85)";
export const EcoCssInJsCOperationTypeLightOpaque = "hsla(var(--c-agnostic-yellow-hsl), 1)";
export const EcoCssInJsCOperationTypeWaterHsl = "var(--c-agnostic-cyan-hsl)";
export const EcoCssInJsCOperationTypeWater = "hsl(var(--c-agnostic-cyan-hsl))";
export const EcoCssInJsCOperationTypeWaterTransparent = "hsla(var(--c-agnostic-cyan-hsl), 0)";
export const EcoCssInJsCOperationTypeWaterMinor = "hsla(var(--c-agnostic-cyan-hsl), 0.15)";
export const EcoCssInJsCOperationTypeWaterWeak = "hsla(var(--c-agnostic-cyan-hsl), 0.3)";
export const EcoCssInJsCOperationTypeWaterMedium = "hsla(var(--c-agnostic-cyan-hsl), 0.5)";
export const EcoCssInJsCOperationTypeWaterHeavy = "hsla(var(--c-agnostic-cyan-hsl), 0.7)";
export const EcoCssInJsCOperationTypeWaterMajor = "hsla(var(--c-agnostic-cyan-hsl), 0.85)";
export const EcoCssInJsCOperationTypeWaterOpaque = "hsla(var(--c-agnostic-cyan-hsl), 1)";
export const EcoCssInJsCOperationTypeMoveHsl = "var(--c-agnostic-plum-hsl)";
export const EcoCssInJsCOperationTypeMove = "hsl(var(--c-agnostic-plum-hsl))";
export const EcoCssInJsCOperationTypeMoveTransparent = "hsla(var(--c-agnostic-plum-hsl), 0)";
export const EcoCssInJsCOperationTypeMoveMinor = "hsla(var(--c-agnostic-plum-hsl), 0.15)";
export const EcoCssInJsCOperationTypeMoveWeak = "hsla(var(--c-agnostic-plum-hsl), 0.3)";
export const EcoCssInJsCOperationTypeMoveMedium = "hsla(var(--c-agnostic-plum-hsl), 0.5)";
export const EcoCssInJsCOperationTypeMoveHeavy = "hsla(var(--c-agnostic-plum-hsl), 0.7)";
export const EcoCssInJsCOperationTypeMoveMajor = "hsla(var(--c-agnostic-plum-hsl), 0.85)";
export const EcoCssInJsCOperationTypeMoveOpaque = "hsla(var(--c-agnostic-plum-hsl), 1)";
export const EcoCssInJsCOperationTypePhotoHsl = "var(--c-agnostic-lime-hsl)";
export const EcoCssInJsCOperationTypePhoto = "hsl(var(--c-agnostic-lime-hsl))";
export const EcoCssInJsCOperationTypePhotoTransparent = "hsla(var(--c-agnostic-lime-hsl), 0)";
export const EcoCssInJsCOperationTypePhotoMinor = "hsla(var(--c-agnostic-lime-hsl), 0.15)";
export const EcoCssInJsCOperationTypePhotoWeak = "hsla(var(--c-agnostic-lime-hsl), 0.3)";
export const EcoCssInJsCOperationTypePhotoMedium = "hsla(var(--c-agnostic-lime-hsl), 0.5)";
export const EcoCssInJsCOperationTypePhotoHeavy = "hsla(var(--c-agnostic-lime-hsl), 0.7)";
export const EcoCssInJsCOperationTypePhotoMajor = "hsla(var(--c-agnostic-lime-hsl), 0.85)";
export const EcoCssInJsCOperationTypePhotoOpaque = "hsla(var(--c-agnostic-lime-hsl), 1)";
export const EcoCssInJsCOperationTypeInspectHsl = "var(--c-agnostic-purple-hsl)";
export const EcoCssInJsCOperationTypeInspect = "hsl(var(--c-agnostic-purple-hsl))";
export const EcoCssInJsCOperationTypeInspectTransparent = "hsla(var(--c-agnostic-purple-hsl), 0)";
export const EcoCssInJsCOperationTypeInspectMinor = "hsla(var(--c-agnostic-purple-hsl), 0.15)";
export const EcoCssInJsCOperationTypeInspectWeak = "hsla(var(--c-agnostic-purple-hsl), 0.3)";
export const EcoCssInJsCOperationTypeInspectMedium = "hsla(var(--c-agnostic-purple-hsl), 0.5)";
export const EcoCssInJsCOperationTypeInspectHeavy = "hsla(var(--c-agnostic-purple-hsl), 0.7)";
export const EcoCssInJsCOperationTypeInspectMajor = "hsla(var(--c-agnostic-purple-hsl), 0.85)";
export const EcoCssInJsCOperationTypeInspectOpaque = "hsla(var(--c-agnostic-purple-hsl), 1)";
export const EcoCssInJsCShadow = "hsla(var(--igs-deep-blue-h), 0%, 60%, var(--alpha-minor))";
export const EcoCssInJsCShadowNav = "hsla(var(--igs-deep-blue-h), 69%, 6%, var(--alpha-weak))";
export const EcoCssInJsCTableRowHighlighted = "hsl(var(--hue-sat), 90%)";
export const EcoCssInJsCTableRowEven = "hsla(var(--igs-deep-blue-hsl), 0.05)";
export const EcoCssInJsCText = "hsl(var(--hue-sat), 13%)";
export const EcoCssInJsCTextSecondary = "hsl(var(--hue-sat), 33%)";
export const EcoCssInJsCTextOnPrimaryBackground = "var(--c-text)";
export const EcoCssInJsCTextOnOppositeBackground = "hsl(var(--hue-sat), 99%)";
export const EcoCssInJsCTextLink = "hsl(var(--c-cta-default-hsl))";
export const EcoCssInJsHueSat = "var(--igs-deep-blue-h), 6%";
export const EcoCssInJsIgsDeepBlueH = 219.6;
export const EcoCssInJsIgsDeepBlueS = 100;
export const EcoCssInJsIgsDeepBlueL = 17.8;
export const EcoCssInJsIgsDeepBlueHsl = "219.6, 100%, 17.8%";
export const EcoCssInJsIgsBlueH = 228.5;
export const EcoCssInJsIgsBlueS = 100;
export const EcoCssInJsIgsBlueL = 67.3;
export const EcoCssInJsIgsBlueHsl = "228.5, 100%, 67.3%";
export const EcoCssInJsIgsMelaninH = 0;
export const EcoCssInJsIgsMelaninS = 20;
export const EcoCssInJsIgsMelaninL = 4.9;
export const EcoCssInJsIgsMelaninHsl = "0, 20%, 4.9%";
export const EcoCssInJsIgsTurquoiseH = 170.6;
export const EcoCssInJsIgsTurquoiseS = 100;
export const EcoCssInJsIgsTurquoiseL = 50;
export const EcoCssInJsIgsTurquoiseHsl = "170.6, 100%, 50%";
export const EcoCssInJsIgsSilverH = 212.7;
export const EcoCssInJsIgsSilverS = 33.3;
export const EcoCssInJsIgsSilverL = 93.5;
export const EcoCssInJsIgsSilverHsl = "212.7, 33.3%, 93.5%";
export const EcoCssInJsIgsPaperWhiteH = 0;
export const EcoCssInJsIgsPaperWhiteS = 0;
export const EcoCssInJsIgsPaperWhiteL = 94.5;
export const EcoCssInJsIgsPaperWhiteHsl = "0, 0%, 94.5%";
export const EcoCssInJsIgsDarkTurquoiseH = 194.3;
export const EcoCssInJsIgsDarkTurquoiseS = 100;
export const EcoCssInJsIgsDarkTurquoiseL = 32.2;
export const EcoCssInJsIgsDarkTurquoiseHsl = "194.3, 100%, 32.2%";
export const EcoCssInJsIgsSkyBlueH = 183.3;
export const EcoCssInJsIgsSkyBlueS = 100;
export const EcoCssInJsIgsSkyBlueL = 49.6;
export const EcoCssInJsIgsSkyBlueHsl = "183.3, 100%, 49.6%";
export const EcoCssInJsIgsBrightGreenH = 150.8;
export const EcoCssInJsIgsBrightGreenS = 100;
export const EcoCssInJsIgsBrightGreenL = 50;
export const EcoCssInJsIgsBrightGreenHsl = "150.8, 100%, 50%";
export const EcoCssInJsIgsDangerH = 0;
export const EcoCssInJsIgsDangerS = 100;
export const EcoCssInJsIgsDangerL = 60;
export const EcoCssInJsIgsDangerHsl = "0, 100%, 60%";
export const EcoCssInJsIgsSuccessH = 164.6;
export const EcoCssInJsIgsSuccessS = 100;
export const EcoCssInJsIgsSuccessL = 32;
export const EcoCssInJsIgsSuccessHsl = "164.6, 100%, 32%";
export const EcoCssInJsIgsWarningH = 32.4;
export const EcoCssInJsIgsWarningS = 100;
export const EcoCssInJsIgsWarningL = 50;
export const EcoCssInJsIgsWarningHsl = "32.4, 100%, 50%";
export const EcoCssInJsBoxShadowBase = "var(--box-shadow-low), 0 var(--sp-xs) var(--sp-xs) calc(var(--sp-xxs) * -0.3) var(--c-shadow)";
export const EcoCssInJsBoxShadowHigh = "var(--box-shadow-base),  0 var(--sp-sm) var(--sp-sm) calc(var(--sp-xs) * -0.6) var(--c-shadow), 0 var(--sp-md) var(--sp-md) calc(var(--sp-sm) * -0.3) var(--c-shadow), 0 var(--sp-lg) var(--sp-lg) calc(var(--sp-md) * -0.6) var(--c-shadow)";
export const EcoCssInJsBoxShadowLow = "0 calc(var(--sp-xxs) / 12) calc(var(--sp-xxs) / 12) var(--c-shadow), 0 var(--sp-xxs) var(--sp-xxs) calc(var(--sp-xxs) * -0.3) var(--c-shadow)";
export const EcoCssInJsBoxShadowInset = "0 calc(var(--sp-md) / 10) calc(var(--sp-md) / 3) var(--c-shadow) inset";
export const EcoCssInJsBrXs = "var(--sp-xxs)";
export const EcoCssInJsBrSm = "var(--sp-xs)";
export const EcoCssInJsBrMd = "var(--sp-sm)";
export const EcoCssInJsBrLg = "var(--sp-md)";
export const EcoCssInJsBrXl = "var(--sp-lg)";
export const EcoCssInJsBrRound = "100vmin";
export const EcoCssInJsBwBase = "calc(var(--sp-sm) / 8)";
export const EcoCssInJsBwThin = "calc(var(--sp-sm) / 12)";
export const EcoCssInJsBwThick = "calc(var(--sp-sm) / 4)";
export const EcoCssInJsSpXxs = "calc(var(--sp-md)  * 0.25)";
export const EcoCssInJsSpXs = "calc(var(--sp-md)  * 0.5)";
export const EcoCssInJsSpSm = "calc(var(--sp-md)  * 0.75)";
export const EcoCssInJsSpMd = "var(--base-size)";
export const EcoCssInJsSpLg = "calc(var(--sp-md)  * 1.5)";
export const EcoCssInJsSpXl = "calc(var(--sp-md)  * 2)";
export const EcoCssInJsSpXxl = "calc(var(--sp-md)  * 2.5)";
export const EcoCssInJsSpXxxl = "calc(var(--sp-md)  * 3)";
export const EcoCssInJsSpXxxxl = "calc(var(--sp-md)  * 4)";
export const EcoCssInJsFfBase = "'InterVariable', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
export const EcoCssInJsFfTitle = "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
export const EcoCssInJsFfMono = "'DM Mono', Consolas, Monaco, Liberation Mono, Lucida Console, monospace";
export const EcoCssInJsFsXxs = "calc(var(--fs-md)  * 0.5)";
export const EcoCssInJsFsXs = "calc(var(--fs-md)  * 0.75)";
export const EcoCssInJsFsSm = "calc(var(--fs-md)  * 0.875)";
export const EcoCssInJsFsMd = "var(--base-size)";
export const EcoCssInJsFsLg = "calc(var(--fs-md)  * 1.25)";
export const EcoCssInJsFsXl = "calc(var(--fs-md)  * 1.5)";
export const EcoCssInJsFsXxl = "calc(var(--fs-md)  * 1.75)";
export const EcoCssInJsFsXxxl = "calc(var(--fs-md)  * 2)";
export const EcoCssInJsFsXxxxl = "calc(var(--fs-md)  * 2.25)";
export const EcoCssInJsFwLight = 200;
export const EcoCssInJsFwBold = 700;
export const EcoCssInJsFwBase = 400;
export const EcoCssInJsLineHeightTight = 1.1;
export const EcoCssInJsLineHeightBase = 1.4;
export const EcoCssInJsLineHeightLoose = 1.7;
export const EcoCssInJsAlphaTransparent = 0;
export const EcoCssInJsAlphaMinor = 0.15;
export const EcoCssInJsAlphaWeak = 0.3;
export const EcoCssInJsAlphaMedium = 0.5;
export const EcoCssInJsAlphaHeavy = 0.7;
export const EcoCssInJsAlphaMajor = 0.85;
export const EcoCssInJsAlphaOpaque = 1;
export const EcoCssInJsBlurSm = "calc(var(--sp-md)  * 0.25)";
export const EcoCssInJsBlurMd = "var(--base-size)";
export const EcoCssInJsBlurLg = "calc(var(--sp-md)  * 2.5)";
export const EcoCssInJsLayoutInlineSizeNarrow = "clamp(calc(var(--fs-md) * 12), calc(var(--fs-md) * 48), calc(100vw - var(--sp-md) - var(--sp-md)))";
export const EcoCssInJsLayoutInlineSizeFill = "calc(100vw - var(--sp-md) - var(--sp-md))";
export const EcoCssInJsLayoutBlockSizeFill = "calc(100vh - var(--sp-md) - var(--sp-md))";